import { GET_STATUS_COUNTS } from '../actions';

export const statusCounts = (state = {}, { type, payload }) => {
    let newState = state;

    if (type === GET_STATUS_COUNTS) {
        newState = {
            ...state,
            ...payload.eventCount,
        };
    }

    return newState;
};
